"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceSpaces = void 0;
const hyphenSymbol = /\{-\}/gi;
const transformHyphens = (str) => {
    if (typeof str === "string") {
        // @ts-expect-error -- TS treats str as T & string, whereas replace will
        // return a string
        return str.replace(hyphenSymbol, "\u00AD");
    }
    return str;
};
const replaceSpaces = (str) => {
    if (typeof str === "string") {
        return str && str.replace(/ /g, "-");
    }
    return "";
};
exports.replaceSpaces = replaceSpaces;
exports.default = transformHyphens;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHJhbnNmb3JtSHlwaGVucy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlscy90cmFuc2Zvcm1IeXBoZW5zLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLE1BQU0sWUFBWSxHQUFHLFNBQVMsQ0FBQztBQUUvQixNQUFNLGdCQUFnQixHQUFHLENBQUksR0FBTSxFQUFLLEVBQUU7SUFDeEMsSUFBSSxPQUFPLEdBQUcsS0FBSyxRQUFRLEVBQUUsQ0FBQztRQUM1Qix3RUFBd0U7UUFDeEUsa0JBQWtCO1FBQ2xCLE9BQU8sR0FBRyxDQUFDLE9BQU8sQ0FBQyxZQUFZLEVBQUUsUUFBUSxDQUFDLENBQUM7SUFDN0MsQ0FBQztJQUNELE9BQU8sR0FBRyxDQUFDO0FBQ2IsQ0FBQyxDQUFDO0FBRUssTUFBTSxhQUFhLEdBQUcsQ0FBQyxHQUFvQixFQUFVLEVBQUU7SUFDNUQsSUFBSSxPQUFPLEdBQUcsS0FBSyxRQUFRLEVBQUUsQ0FBQztRQUM1QixPQUFPLEdBQUcsSUFBSSxHQUFHLENBQUMsT0FBTyxDQUFDLElBQUksRUFBRSxHQUFHLENBQUMsQ0FBQztJQUN2QyxDQUFDO0lBQ0QsT0FBTyxFQUFFLENBQUM7QUFDWixDQUFDLENBQUM7QUFMVyxRQUFBLGFBQWEsaUJBS3hCO0FBRUYsa0JBQWUsZ0JBQWdCLENBQUMifQ==